// extracted by mini-css-extract-plugin
module.exports = {"plus":"ab_ae"};